let total_accounts = 0;
let temp = 100;

$(document).ready(function() {
  if (!$('#likert_scale_page_mandatory_correct').is(':checked')) {
    $('.likert-scale-explanation-field').css("display", "none");
  }

  $('#likert_scale_page_mandatory_correct').on('click', function() {
    if ($('#likert_scale_page_mandatory_correct').is(':checked')) {
      if (!$('#likert_scale_page_feedback').is(':checked')) {
        $('#likert_scale_page_feedback').click();
      }
      $('.likert-scale-page-explanation-field').css("display", "block");
    } else {
      $('.likert-scale-page-explanation-field').css("display", "none");
    }
  });

  $('#likert_scale_page_feedback').on('click', function() {
    if (!$('#likert_scale_page_feedback').is(':checked')) {
      if ($('#likert_scale_page_mandatory_correct').is(':checked')) {
        $('#likert_scale_page_mandatory_correct').click();
      }
      return $('.essay-page-explanation-field').css("display", "none");
    }
  });
});

window.remove_likert_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
};

window.add_likert_fields = function(link, association, fields_to_clone, view) {
  if (view == 'new') {
    total_accounts++;
  }
  else {
    temp++;
    total_accounts = temp;
  }
  
  let regexp = new RegExp("new_" + association, "g");
  $('.likert-scale-answers').append(fields_to_clone.replace(regexp, total_accounts));
};